<template>
  <div class="flex flex-col">
    <TableDocs type="Taches de production" api-type="production" number-prefix="PRODUCTION" />
  </div>
</template>

<script>
import TableDocs from '@/components/Table/Docs'

export default {
  components: {
    TableDocs,
  },
  theme() {
    return {
      title: 'Taches de production',
    }
  },
}
</script>

<style></style>
